// extracted by css-extract-rspack-plugin
export default {"Container":"cOGv3","Header":"EN6M1"};